import { connect } from "react-redux";

export const readAuthFromStorage = () => {
  try {
    const raw = localStorage.getItem("authInfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const mapNotificationPageStateToProps = (state) => {
  const stored = readAuthFromStorage();
  return {
    userRoles:
      state.auth?.roles ||
      state.auth?.userRoles ||
      stored?.roles ||
      stored?.userRoles ||
      [],
    userLevel: state.auth?.userLevel ?? stored?.userLevel ?? 0,
  };
};

export const withNotificationPageAuth = (Component) =>
  connect(mapNotificationPageStateToProps)(Component);
